import gql from 'graphql-tag';

export const CASE_CUSTOMER_QUERY_NAME =
  'compositions_CustomersWidget_customerQuery';

export const customerQuery = gql`
  query ${CASE_CUSTOMER_QUERY_NAME} (
    $caseNumber: String!
  ) {
    case (
      caseNumber: $caseNumber
    ) {
      id
      customerTerminalLocation
      customer(useCachedDataForCase: true) {
        ... on Customer {
          type
          billTo
          city
          id
          name
          shipTo
          state
          singleCallRequested
          terminalNumber
          billingPreferences {
            terminalLocation
          }
        }
      }
      customerDomicile {
        ... on Customer {
          type
          billTo
          city
          id
          name
          shipTo
          state
          terminalNumber
          billingPreferences {
            terminalLocation
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/caseCustomerQuery.js